<div class="add-filter">
    <div class="add-filter__toolbar">
        <button type="button" class="add-filter__global-filter-btn" (click)="onOpenGlobalFilter()">
            <!-- <mat-icon aria-hidden="true">tune</mat-icon> -->
            <span>Manage global filter</span>
        </button>
    </div>

    <div class="add-filter__table">
        <div class="add-filter__row add-filter__row--head">
            <span class="add-filter__col add-filter__col--handle"></span>
            <span class="add-filter__col add-filter__col--name">Filter name</span>
            <span class="add-filter__col add-filter__col--type">Type</span>
            <span class="add-filter__col add-filter__col--column">Selected data column</span>
            <span class="add-filter__col add-filter__col--actions"></span>
        </div>

        <div class="add-filter__list" cdkDropList [cdkDropListData]="rows" (cdkDropListDropped)="onDrop($event)">
            <div class="add-filter__row" *ngFor="let row of rows; trackBy: trackByRowId" cdkDrag [cdkDragData]="row">
                <span class="add-filter__col add-filter__col--handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                </span>

                <div class="add-filter__col add-filter__col--name">
                    <input type="text" class="add-filter__input" placeholder="Filter name" [(ngModel)]="row.name"
                        (ngModelChange)="onFieldChange()" />
                    <span class="add-filter__error" *ngIf="isDuplicateName(row)">Must be unique</span>
                </div>

                <div class="add-filter__col add-filter__col--type">
                    <mat-select class="add-filter__select" placeholder="Select type" [(ngModel)]="row.type"
                        (selectionChange)="onTypeChange(row)">
                        <mat-option *ngFor="let opt of controlTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                    </mat-select>
                </div>

                <div class="add-filter__col add-filter__col--column">
                    <button type="button" class="add-filter__column-trigger" (click)="toggleColumnPicker(row)">
                        <span class="add-filter__column-trigger-text">{{ selectedColumnsLabel(row) }}</span>
                        <mat-icon>expand_more</mat-icon>
                    </button>

                    <div class="add-filter__column-picker" *ngIf="row.columnPickerOpen">
                        <div class="add-filter__column-picker-head">
                            <span>Selected data column</span>
                            <span class="add-filter__column-picker-count">
                                {{ row.selectedColumns.length }} selected column{{ row.selectedColumns.length === 1 ? '' : 's' }}
                            </span>
                        </div>
                        <input type="text" class="add-filter__column-search" placeholder="Search columns..."
                            [(ngModel)]="row.columnSearch" />
                        <div class="add-filter__column-groups">
                            <div class="add-filter__column-group" *ngFor="let group of filteredGroups(row)">
                                <button type="button" class="add-filter__column-group-head"
                                    (click)="toggleGroup(row, group.group)">
                                    <mat-icon>{{ isGroupExpanded(row, group.group) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                                    <span class="add-filter__column-group-name">{{ group.group }}</span>
                                    <span class="add-filter__column-group-count">{{ group.columns.length }} columns</span>
                                </button>
                                <div class="add-filter__column-list" *ngIf="isGroupExpanded(row, group.group)">
                                    <label class="add-filter__column-item" *ngFor="let col of group.columns">
                                        <input [type]="canSelectMultipleColumns(row) ? 'checkbox' : 'radio'" [name]="'col-' + row.id"
                                            [checked]="isColumnSelected(row, col)" (change)="onColumnToggle(row, col)" />
                                        <span class="add-filter__column-item-name">
                                            {{ col.name }}<span class="add-filter__column-item-meta" *ngIf="columnMeta(col)"> &bull; {{ columnMeta(col) }}</span>
                                        </span>
                                        <span class="add-filter__column-item-tag" *ngIf="isColumnSelected(row, col)">Selected</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="add-filter__col add-filter__col--actions">
                    <button type="button" class="add-filter__icon-btn" title="Manage properties" (click)="openProperties(row)">
                        <mat-icon>tune</mat-icon>
                    </button>
                    <button type="button" class="add-filter__icon-btn add-filter__icon-btn--danger" title="Remove filter"
                        (click)="removeRow(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <button type="button" class="add-filter__add-btn" (click)="addRow()">
        <mat-icon>add</mat-icon> Add filter
    </button>

    <p class="add-filter__summary">{{ summaryText }}</p>

    <app-property-panel [open]="!!activeRow" title="Filter properties" [fields]="propertyFields"
        [values]="activePropertyValues" (valueChange)="onPropertyValueChange($event)" (closed)="closeProperties()">
    </app-property-panel>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #globalFilterModal class="modal-demo global-filter-popup"
    (closeModal)="onGlobalFilterCancelled()">
    <ng-container class="app-modal-header">Manage global filter</ng-container>
    <ng-container class="app-modal-body">
        <app-global-filter-modal #globalFilterModalBody [columnOptions]="globalFilterColumnOptions"
            (cancelled)="onGlobalFilterCancelled()" (conditionsSaved)="onGlobalFilterSaved($event)">
        </app-global-filter-modal>
    </ng-container>
</app-modal>
